import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { SocialShareComponent } from './social-share.component'
import { ShareButtonComponent } from './share-button/share-button.component'
import { ShareButtonDirective } from './share-button/share-button.directive'

import { ShareService } from './shared/share/share.service'

import { ShareProvider } from './shared/share-provider.enum'

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    SocialShareComponent
  ],
  declarations: [
    SocialShareComponent,
    ShareButtonComponent,
    ShareButtonDirective
  ],
  providers: [
    ShareService
  ]
})
export class SocialShareModule { }

export { ShareProvider }



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/social-share/social-share.module.ts